module.exports = __webpack_public_path__ + "static/media/0023_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_NAVONA_HORIZONTALE.c5e7250b.png";